<template>
    <b-card no-body>

        <v-table    ref="table"
                    with-items
                    :items="items"
                    name="tachograph-driver-working"
                    pagination="client"
                    :settings="false"
                    search
                    :fields="fields">
                        <template #additional-thead>
                            <tr v-if="c_hasTotal">
                                <th></th>
                                <th class="v-table-column-sticky align-middle">
                                    {{c_month}} {{showingYear}}
                                </th>
                                <th  class="align-middle text-center">
                                    <span class="font-weight-bolder text-success"><short-text text="Aylık Toplam Sürüş Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalDrivingTime')}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-primary"><short-text text="Aylık Toplam Rölanti Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalWorkingTime')}}
                                </th>
                                <th class="align-middle text-center">
                                    <span class="font-weight-bolder text-warning"><short-text text="Aylık Toplam Çalışma Zamanı"></short-text></span><br/>
                                    {{$safe(monthlyTotal,'MonthlyTotalDrivingAndWorkingTime')}}
                                </th>
                                <template v-for="(total,index) in totals">
                                    <td class="text-center" :key="'DTDT'+index">
                                        <span class="font-weight-bolder text-success"><short-text text="Günlük Toplam Sürüş Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalDrivingTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTWT'+index">
                                        <span class="font-weight-bolder text-primary"><short-text text="Günlük Toplam Rölanti Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalWorkingTime || '-'}}
                                    </td>
                                    <td class="text-center" :key="'DTAT'+index">
                                        <span class="font-weight-bolder text-warning"><short-text text="Günlük Toplam Çalışma Zamanı"></short-text></span><br/>
                                        {{total.DailyTotalDrivingAndWorkingTime || '-'}}
                                    </td>
                                </template>
                            </tr>
                            <tr v-if="c_hasTotal">
                                <th colspan="1500"></th>
                            </tr>
                        </template>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success" v-on:click="getTachograph">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto">
                                    <b-dropdown variant="dark">
                                        <template #button-content>
                                            <feather-icon icon="FilterIcon" class="mr-50"></feather-icon>
                                            Filtrele
                                        </template>
                                        <div class="pr-50 pl-50">
                                            <div class="p-25" v-for="f in filters" :key="f.key">
                                                <b-form-checkbox :disabled="f.value == true && c_onlyOneFilterDisabled" v-on:change="filterData(f.key,$event)" class="text-nowrap" v-model="f.value"><span class="font-weight-bolder" :class="f.variant">{{f.key}}</span> - {{f.text}}</b-form-checkbox>
                                            </div>
                                        </div>
                                    </b-dropdown>
                                </div>
                            </div>
                        </template>
                        <template #information>
                            <b>'-' (tire)</b> ifadesi o gün için veri olmadığı anlamına gelir.
                        </template>
                </v-table>  
    </b-card>
</template>

<script>
import {BCard,BFormCheckbox,BDropdown} from 'bootstrap-vue'
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations' 
import ShortText from '@/components/ShortText.vue'

export default {
    components:{
        BCard,
        BFormCheckbox,
        BDropdown,
        ShortText
    },
    data(){
        return{
            month:null,
            showingMonth:null,
            years:[],
            year:null,
            showingYear:null,
            totals:[],
            monthlyTotal:{
                MonthlyTotalDrivingTime:null,
                MonthlyTotalWorkingTime:null,
                MonthlyTotalDrivingAndWorkingTime:null
            },
            items:[],
            fields:[
                { name:"Sıra", key:"Order", tdClass:"text-center font-weight-bolder"},
                { name:"Sürücü Bilgisi",tdClass:'text-nowrap',key:"DriverFullName",sticky:true},
                { name:"TSZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalDrivingTime",tooltip:'Toplam Sürüş Zamanı'},
                { name:"TRZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalWorkingTime",tooltip:'Toplam Rölanti Zamanı'},
                { name:"TÇZ",tdClass:'text-nowrap font-weight-bolder border-right',key:"MonthlyTotalDrivingAndWorkingTime",tooltip:'Toplam Çalışma Zamanı'},
            ],
            filters:[
                {key:"SZ",variant:"text-success",text:"Sürüş Zamanı",value:true},
                {key:"RZ",variant:"text-primary",text:"Rolanti Zamanı",value:true},
                {key:"TZ",variant:"text-warning",text:"Toplam Zaman",value:true},
            ],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            loading:false,
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureFields(Date.now())
        this.getTachograph()
    },
    methods:{
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
        },
        configureFields(date){
            this.fields = this.fields.filter(f=> !f.date)
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForObject = _date.format('YYYY-MM-DD')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.fields.push(
                    { name: _dateForName,
                    date:true,
                        children:[
                            { name:"SZ", thClass:"text-success", key:'Data.'+_dateForObject+'.DrivingTime',tooltip:"Sürüş Zamanı"},
                            { name:"RZ", thClass:"text-primary", key:'Data.'+_dateForObject+'.WorkingTime',tooltip:"Rolanti Zamanı"},
                            { name:"TÇZ", thClass:"text-warning", tdClass:"font-weight-bolder border-right", key:'Data.'+_dateForObject+'.TotalWithDrivingAndWorking',tooltip:"Toplam Çalışma Zaman"},
                        ]
                    },
                )
            })
        },
        configureData(data){
            data.forEach(d=>{
                let currentDays = d.Data.reduce((object,dt)=>{ 
                    let days = Object.keys(dt).filter(k=> k != 'DriverFullName') 
                    days.forEach(day=>{
                        Object.assign(object,{[day]:dt[day]})
                    })
                    return object
                },{})
                d.Data = currentDays
            })
            return data
        },
        consfigureTotalData(data){
            let resultData = []
            let date = moment(this.year+'-'+this.month,'YYYY-MM')
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days').format('DD.MM.YYYY')
                let item = data.find(d=>d.Date == _date)
                let resultItem = { DailyTotalDrivingAndWorkingTime:null, DailyTotalDrivingTime:null, DailyTotalWorkingTime:null, Date:_date }
                if(item){
                    resultItem.DailyTotalDrivingAndWorkingTime = item.DailyTotalDrivingAndWorkingTime
                    resultItem.DailyTotalDrivingTime = item.DailyTotalDrivingTime
                    resultItem.DailyTotalWorkingTime = item.DailyTotalWorkingTime
                }
                resultData.push(resultItem)
            })
            return resultData
        },
        getTachograph(){
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.Tachograph.MonthlyDrivingWithWorkingTime(this.month,this.year).then(res=>{
                let date = moment(this.year+'-'+this.month,'YYYY-MM')
                this.configureFields(date)
                this.showingMonth = this.month
                this.showingYear = this.year
                this.items = this.configureData(res.data.resData)
                this.totals = this.consfigureTotalData(res.data.dailyData)
                this.monthlyTotal = res.data.monthlyTotalSumByActivityType[0]
                this.$refs.table.setLoading(false)
            })
        },
        filterData(key,e){
            this.$refs.table.dataVisibility("name",key,e)
        },
    },
    computed:{
        c_onlyOneFilterDisabled(){
            return this.filters.filter(f=> f.value == true). length == 1 ? true : false
        },
        c_month(){
            return this.months.find(m=> m.index == this.showingMonth)?.name || ""
        },
        c_hasTotal(){
            return this.totals.filter(t =>
                t.DailyTotalDrivingAndWorkingTime != null ||
                t.DailyTotalDrivingTime != null ||
                t.DailyTotalWorkingTime != null
            ).length > 0 ? true : false
        }
    }
}
</script>

<style lang="scss">
</style>